"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const string_similarity_1 = __importDefault(require("string-similarity"));
const next_app_controller_reducers_sagas_main_reducer_n_1 = require("@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n");
const next_components_button_n_1 = __importStar(require("@gerenciatd/next.components.button-n"));
const constants_1 = require("../../../constants");
const filePath = 'header/PillSlider/index.js';
class PillSlider extends react_1.Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            // si es moible centro la pill marcada
            try {
                const element = document.querySelector('.PillsContainer.mobile .pill-selected');
                let coords = null;
                let area = null;
                if (element && element.getBoundingClientRect) {
                    coords = element.getBoundingClientRect();
                }
                if (coords) {
                    area = document.querySelector('.PillsContainer.mobile .PillSection');
                }
                if (area && coords && coords.left) {
                    area.scroll(coords.left, 0);
                }
            }
            catch (error) {
                const { throwSonda } = this.props;
                throwSonda({
                    filePath,
                    processName: 'No se pudo centrar la pill seleccionada',
                    error,
                    kind: next_app_controller_reducers_sagas_main_reducer_n_1.SONDA_KIND.ERROR,
                });
            }
        };
        this.decideIfAnyIsSelected = (pillsArray) => {
            const { location } = this.props;
            const newPillsArray = [...pillsArray];
            try {
                // reseteamos el estado de las pills antes de empezar
                newPillsArray.forEach((eachitemPill, index) => {
                    if (eachitemPill && eachitemPill.selected) {
                        newPillsArray[index].selected = false;
                    }
                });
                let similarityResults = [];
                newPillsArray.forEach(((itemPill, index) => {
                    if (itemPill.action
                        && itemPill.action.link
                        && location.pathname
                        && location.pathname.indexOf(itemPill.action.link) !== -1) {
                        const similar = string_similarity_1.default.compareTwoStrings(location.pathname, itemPill.action.link);
                        similarityResults.push({
                            index,
                            similar,
                            link: itemPill.action.link,
                        });
                    }
                }));
                if (similarityResults && similarityResults.length > 0) {
                    similarityResults = similarityResults.sort((itemA, itemB) => {
                        const result = itemB.similar - itemA.similar;
                        return result;
                    });
                    const betterResult = similarityResults.shift();
                    const { index } = betterResult;
                    newPillsArray[index].selected = true;
                }
            }
            catch (err) {
                // console.error(err);
            }
            finally {
                return newPillsArray;
            }
        };
        this.getPillColor = (differentiated, selected = false, segment = constants_1.PARTICULARES) => {
            const { isPriority } = this.props;
            let res = '';
            if (segment === constants_1.PARTICULARES) {
                res = selected ? next_components_button_n_1.BUTTON_TYPE.HEADER : next_components_button_n_1.BUTTON_TYPE.HEADER_REVERSE;
                if (isPriority && !selected) {
                    res = next_components_button_n_1.BUTTON_TYPE.HEADER_PRIORITY_REVERSE;
                }
                if (isPriority && selected) {
                    res = next_components_button_n_1.BUTTON_TYPE.HEADER_PRIORITY;
                }
            }
            if (segment === constants_1.EMPRESAS) {
                res = selected ? 'blue_dark' : 'white_reverse';
                if (selected) {
                    res = 'white';
                }
            }
            return res;
        };
        let { pillsArray } = this.props;
        pillsArray = pillsArray.filter(item => item.visible === true
            && item && item.action && item.action.type === 'link');
        this.state = {
            pillsArray,
        };
    }
    render() {
        let { pillsArray } = this.state;
        const { isPriority, segment } = this.props;
        pillsArray = this.decideIfAnyIsSelected(pillsArray);
        return (pillsArray && Array.isArray(pillsArray) && (react_1.default.createElement("div", { className: "PillSection" }, pillsArray.map((pillItem, index) => {
            const { differentiated, action, text, taggingInfo, selected, target, } = pillItem;
            const buttonType = this.getPillColor(differentiated, selected, segment);
            const cssPriority = isPriority ? ` ${constants_1.PRIORITY}` : '';
            const cssLast = index === (pillsArray.length - 1) ? ' last' : '';
            const cssFirst = index === 0 ? ' first' : '';
            const cssSelected = selected ? ' pill-selected' : '';
            return (react_1.default.createElement(next_components_button_n_1.default, { key: text, taggingInfo: taggingInfo, href: action.link, borderRadius: next_components_button_n_1.BUTTON_BORDER_RADIUS.BIG, className: `PillItem${cssLast}${cssFirst}${cssPriority}${cssSelected}`, label: text, buttonType: buttonType, height: next_components_button_n_1.BUTTON_HEIGHT.SMALL, target: target, segment: segment }));
        }))));
    }
}
// const mapStateToProps = state => ({
//   location: state.easyHeader.location,
// })
const mapDispatchToProps = dispatch => ({
    handleSeveral: errorData => dispatch(errorActions.handleSeveral(errorData)),
    throwSonda: data => dispatch(next_app_controller_reducers_sagas_main_reducer_n_1.actions.throwSonda(data)),
});
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(PillSlider);
//# sourceMappingURL=index.js.map